import { Slide } from "react-reveal";

const SystemDevelopmentOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't rely on pre-built systems or rigid platforms. Every
                    client's system is custom developed to match your exact work
                    flows and needs - giving you full control, better
                    performance and long-term scalability.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>Architecture & Cores</h3>
                      <ul>
                        <li>
                          <span>Custom business & institutional systems</span>
                        </li>
                        <li>
                          <span>Web-based, cloud-based & hybrid systems</span>
                        </li>
                        <li>
                          <span>Scalable system architecture design</span>
                        </li>
                        <li>
                          <span>Modular system design</span>
                        </li>
                        <li>
                          <span>
                            Backend development (APIs, Services, Logic)
                          </span>
                        </li>
                        <li>
                          <span>
                            Frontend development (Interfaces & Dashboards)
                          </span>
                        </li>
                        <li>
                          <span>Multi-locations/multi-branch systems</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Database & Data Management</h3>
                      <ul>
                        <li>
                          <span>Database architecture design (SQL/NoSQL)</span>
                        </li>
                        <li>
                          <span>Data modeling & structuring</span>
                        </li>
                        <li>
                          <span>Secure data storage & encryption</span>
                        </li>
                        <li>
                          <span>Data migration (from legacy systems)</span>
                        </li>
                        <li>
                          <span>Backup systems & data recovery setup</span>
                        </li>
                        <li>
                          <span>Data synchronization (across systems)</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>System Integration & APIs</h3>
                      <ul>
                        <li>
                          <span>Mobile app integration</span>
                        </li>
                        <li>
                          <span>API development (REST/custom APIs)</span>
                        </li>
                        <li>
                          <span>
                            Third-party integration(ERP, Payment gateways, CRM)
                          </span>
                        </li>
                        <li>
                          <span>
                            Payment systems integration (card, mobile money,
                            POS, crypto)
                          </span>
                        </li>
                        <li>
                          <span>
                            External platforms & services integrations
                          </span>
                        </li>
                        <li>
                          <span>Real-time data exchange between systems</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Workflow Automation & Process Optimization</h3>
                      <ul>
                        <li>
                          <span>AI powered automation</span>
                        </li>
                        <li>
                          <span>Business process automation</span>
                        </li>
                        <li>
                          <span>Workflow design & optimization</span>
                        </li>
                        <li>
                          <span>Task automation & triggers</span>
                        </li>
                        <li>
                          <span>Notifications (Email, SMS, WhatsApp)</span>
                        </li>
                        <li>
                          <span>Approval systems & role-based workflows</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Security & Access Control</h3>
                      <ul>
                        <li>
                          <span>Advanced system security implementation</span>
                        </li>
                        <li>
                          <span>Role-based access control (RBAC)</span>
                        </li>
                        <li>
                          <span>
                            Authentication Systems (login, 2FA, validation)
                          </span>
                        </li>
                        <li>
                          <span>Data protection & encryption</span>
                        </li>
                        <li>
                          <span>Activity logs & audit trails</span>
                        </li>
                        <li>
                          <span>Secure APIs & server configurations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>User Interface & Experience Design</h3>
                      <ul>
                        <li>
                          <span>Clean, intuitive dashboards</span>
                        </li>
                        <li>
                          <span>Custom user interfaces</span>
                        </li>
                        <li>
                          <span>Mobile responsive system design</span>
                        </li>
                        <li>
                          <span>Multi-user environments</span>
                        </li>
                        <li>
                          <span>User roles, permissions & views</span>
                        </li>
                        <li>
                          <span>Advanced analytics & reports</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Performance & Scalability</h3>
                      <ul>
                        <li>
                          <span>High-performance optimization</span>
                        </li>
                        <li>
                          <span>Fast load times & efficient processing</span>
                        </li>
                        <li>
                          <span>Scalable infrastructure for growth</span>
                        </li>
                        <li>
                          <span>Load handling & system stability</span>
                        </li>
                        <li>
                          <span>Code optimization & best practices</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Deployment, Testing & Infrastructure</h3>
                      <ul>
                        <li>
                          <span>System testing & quality assurance (QA)</span>
                        </li>
                        <li>
                          <span>Bug fixing & performance testing</span>
                        </li>
                        <li>
                          <span>Deployment (Cloud, server, hybrid)</span>
                        </li>
                        <li>
                          <span>Hosting & infrastructure setup</span>
                        </li>
                        <li>
                          <span>Domain & server configurations</span>
                        </li>
                        <li>
                          <span>Continous integration & updates</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Training, Support & Maintenance</h3>
                      <ul>
                        <li>
                          <span>Team training & system usage</span>
                        </li>
                        <li>
                          <span>Documentation & user guides</span>
                        </li>
                        <li>
                          <span>Ongoing technical support</span>
                        </li>
                        <li>
                          <span>System monitoring & maintenance</span>
                        </li>
                        <li>
                          <span>Updates & feature improvements</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemDevelopmentOffers;
